export default __webpack_public_path__ + "static/media/bg4.eea23e69.jpg";